export default __webpack_public_path__ + "static/media/ersaweb-amistad-me204129dico-330x330.6019cf83.webp";